import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

interface Props {
  readonly title: string;
  readonly message: string;
  readonly children?: React.ReactNode;
}

export const NoResultsView: React.FC<Props> = ({
  title,
  message,
  children,
}: Props): React.ReactElement => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.textBox}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body2" color="custom.LightGray">
          {message}
        </Typography>
        {children && <Box sx={styles.childrenBox}>{children}</Box>}
      </Box>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  childrenBox: {
    marginTop: 2,
  },
};
